import { BrowserRouter } from "react-router-dom";
import RouterComponent from "./routes";

function App() {
  return (
    <BrowserRouter>
      <RouterComponent />
    </BrowserRouter>
  );
}

export default App;
